module.exports = __webpack_public_path__ + "img/banner01.2e336ecf.jpg";